module.exports = __webpack_public_path__ + "img/pe.8254a0da.svg";